import React from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Radio } from 'core-components/library/radio'

import styles from './InScopeController.module.scss'

interface IProps {
  notInScope: boolean
  onChange: (value: number) => void
  disabled?: boolean
}

enum INSCOPE_RADIO_VALUES {
  inScope = 'inscope',
  notInScope = 'notinscope',
}
export const InScopeController = ({ notInScope, onChange, disabled }: IProps) => {
  const changeHandle = (value: INSCOPE_RADIO_VALUES) => {
    if (value === INSCOPE_RADIO_VALUES.inScope) {
      onChange(0)
    } else {
      onChange(1)
    }
  }

  return (
    <div>
      <Translation text="jbp-partner-scope-management-in-scope-controller" />
      <div className={styles.radioWrapper}>
        <Radio
          disabled={disabled}
          className={styles.radioWrapper_item}
          checked={!notInScope}
          value={INSCOPE_RADIO_VALUES.inScope}
          onChange={changeHandle}
          label={<Translation text="jbp-partner-scope-management-in-scope" />}
        />
        <Radio
          disabled={disabled}
          checked={notInScope}
          value={INSCOPE_RADIO_VALUES.notInScope}
          onChange={changeHandle}
          label={<Translation text="jbp-partner-scope-management-not-in-scope" />}
        />
      </div>
    </div>
  )
}
